import { useState, useEffect } from 'react';
import { Getuserslist, GetNewUsersList } from '../services/userManagementservice';

export const useUsers = () => {
    const[users, setUsers] = useState([]);
    
    useEffect(() => {
        getUsers();
    }, []);

    const getUsers = async () => {
        try {
            await GetNewUsersList().then((resp) => {
                let templist = []
                if (resp.status == "Ok") {
                    templist = resp.message
                    setUsers(templist)
                } else if(resp.Status === "success"){
                    setUsers(resp.Data);
                } 
            })
        } catch (error) {
            console.error(error)
        }
    }

    return { users, getUsers, setUsers };
}